// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3SXUB","noInteraction":"EventWrapper_noInteraction__12h0b","pointerPassthrough":"EventWrapper_pointerPassthrough__1LFtJ"};